import { useField } from 'formik';
import CustomSelect from '../SpecialInput/CustomSelect/CustomSelect';

function SelectField({ ...props }) {
  const [field, meta] = useField(props);

  return (
    <CustomSelect
      labelText={props.placeholder}
      id={field.name}
      formControlProps={{ fullWidth: true }}
      inputProps={{ ...field, ...props }}
      error={meta.touched && !!meta.error}
    />
  );
}

export default SelectField;
